import { CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon } from '@mui/icons-material';

const CheckBoxOutlineBlank = (): JSX.Element => <CheckBoxOutlineBlankIcon fontSize="inherit" />;

export default CheckBoxOutlineBlank;
